<template>
  <div class="substance_edit-help">
    <div class="ls-card">
      <el-page-header content="产品列表" @back="$router.go(-1)" />
    </div>
    <div class="ls-card m-t-16 form-container">
      <el-form size="small" inline label-width="100px">
        <el-form-item label="产品名称">
          <el-input v-model="queryObj.product_name" />
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="getList"
            >搜索</el-button
          >
          <el-button size="small" @click="reset">重置</el-button>
          <el-button type="success" size="small" @click="update"
            >更新</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="ls-card m-t-16">
      <el-table :data="pager.lists" size="small">
        <el-table-column label="产品名称" prop="product_name" />
        <el-table-column label="详情" prop="description" />
        <el-table-column label="创建时间" prop="create_time" />
      </el-table>
    </div>

    <el-dialog :visible.sync="visible" title="同步产品">
      <el-form size="small" ref="formRef" :model="handleData">
        <el-form-item
          label-width="100px"
          v-for="(item, index) in form"
          :label="item.name"
          :key="index"
          :prop="item.key"
          :rules="{
            required: item.required,
            message: `${item.name}不能为空`,
            trigger: 'blur',
          }"
        >
          <el-select
            v-if="item.type === 'select'"
            v-model="handleData[item.key]"
          >
            <el-option
              v-for="(items, index) in item.options"
              :key="items.key"
              :label="items.name"
              :value="items.key"
            ></el-option>
          </el-select>
          <material-select
            v-else-if="item.type === 'image'"
            :limit="1"
            v-model="handleData[item.key]"
          />
          <el-input
            v-else-if="item.type === 'text'"
            v-model="handleData[item.key]"
          />
        </el-form-item>
        <el-form-item>
          <div class="flex row-right col-center">
            <el-button size="small" @click="cancel">取消</el-button>
            <el-button size="small" type="primary" @click="confirm"
              >确认</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { RequestPaging } from "@/utils/util";
import {
  apiExpressSystemExpressProductLists,
  apiExpressSystemExpressProductAccountFrom,
  apiExpressSystemExpressProductSync,
} from "@/api/express.ts";
import MaterialSelect from "@/components/material-select/index.vue";
export default {
  components: {
    MaterialSelect,
  },
  data() {
    return {
      apiExpressSystemExpressProductLists,
      pager: new RequestPaging(),
      queryObj: {
        system_express_id: "",
        product_name: "",
      },
      handleData: {},
      form: [],
      visible: false,
    };
  },
  methods: {
    confirm() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          apiExpressSystemExpressProductSync({
            system_express_id: this.queryObj.system_express_id,
            data: {
              ...this.handleData,
            },
          }).then((res) => {
            this.$message.success("同步成功");
            this.visible = false;
            this.getList();
          });
        }
      });
    },
    cancel() {
      this.visible = false;
      Object.keys(this.handleData).forEach((item) => {
        this.handleData[item] = "";
      });
    },
    update() {
      apiExpressSystemExpressProductAccountFrom({
        system_express_id: this.queryObj.system_express_id,
      }).then((res) => {
        this.form = res;
        const obj = {};
        res.forEach((v) => {
          obj[v.key] = "";
        });
        this.handleData = obj;
        this.visible = true;
      });
    },
    reset() {
      this.queryObj.product_name = "";
      this.getList();
    },
    getList() {
      this.pager.request({
        callback: apiExpressSystemExpressProductLists,
        params: {
          ...this.queryObj,
        },
      });
    },
  },
  created() {
    this.queryObj.system_express_id = this.$route.query.id;
    this.getList();
  },
};
</script>
